export default "__VITE_ASSET__sokuhrBo__"